import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  Signal,
  viewChild,
} from '@angular/core';

import { SnackbarComponent } from '../snackbar.component';
import { NotificationConfig, SnackbarService } from '../snackbar.service';

@Component({
  selector: 'twc-multiple-snackbar-container',
  imports: [SnackbarComponent],
  templateUrl: './multiple-snackbar-container.component.html',
  styleUrls: ['./multiple-snackbar-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultipleSnackbarContainerComponent {
  snackbars: Signal<NotificationConfig[]> = computed(() =>
    this._snackbarService.snackBars$()
  );

  private _containerRef =
    viewChild<ElementRef<HTMLDivElement>>('snackbarContainer');

  private _snackbarService = inject(SnackbarService);
  private _cdr = inject(ChangeDetectorRef);

  constructor() {
    effect(() => {
      this._togglePopover(this.snackbars().length > 0);
      this._cdr.markForCheck();
    });
  }

  private _togglePopover(hasSnackbars: boolean): void {
    const container = this._containerRef()?.nativeElement;

    // showPopover()/hidePopover() throw on a disconnected element or when
    // the popover is already in the requested state
    if (!container?.isConnected) {
      return;
    }

    if (hasSnackbars && !container.matches(':popover-open')) {
      container.showPopover();
    } else if (!hasSnackbars && container.matches(':popover-open')) {
      container.hidePopover();
    }
  }
}
